import { useState } from "react";
import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material";
import { GroupsOutlined as MitiIcon, OpenInNew as AbrirIcon } from "@mui/icons-material";
import { useTareasExamen } from "../../queries/useTareas";
import { defensaService } from "../../services/defensaService";
import { mensajeDeError } from "../../utils/errores";

/**
 * Lo que el Examen de Título espera de quien entra, arriba de «Mis Procesos»: al estudiante,
 * crear la agenda en Miti, elegir el horario o agendar; a cada integrante, indicar su
 * disponibilidad con su enlace personal. Los correos pueden no llegar: esto queda a la vista
 * mientras siga pendiente.
 */
export default function TareasExamen() {
  const tareas = useTareasExamen();
  const [abriendo, setAbriendo] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  if (!tareas.length) return null;

  const coordinar = async (instancia: number) => {
    setAbriendo(instancia);
    setError(null);
    try {
      window.open(await defensaService.enlaceMiti(instancia), "_blank", "noopener");
    } catch (e) {
      setError(mensajeDeError(e, "No se pudo abrir Miti."));
    } finally {
      setAbriendo(null);
    }
  };

  return (
    <Stack spacing={1.5} sx={{ mb: 3 }}>
      {tareas.map((t) => (
        <Alert key={`${t.tipo}-${t.instancia}`} severity="warning" icon={<MitiIcon />}>
          <AlertTitle sx={{ mb: 0.25 }}>{t.titulo}</AlertTitle>
          <Typography variant="body2">{t.detalle}</Typography>
          <Box sx={{ mt: 1 }}>
            {t.tipo === "coordinar_examen" && t.instancia && (
              <Button size="small" variant="contained" startIcon={<MitiIcon />} onClick={() => coordinar(t.instancia!)} disabled={abriendo === t.instancia}>
                Coordinar en Miti
              </Button>
            )}
            {t.externo && (
              <Button size="small" variant="contained" href={t.link} target="_blank" rel="noreferrer" endIcon={<AbrirIcon fontSize="small" />}>
                {t.tipo === "elegir_horario" ? "Elegir el horario en Miti" : "Indicar mi disponibilidad en Miti"}
              </Button>
            )}
            {t.tipo === "agendar_examen" && (
              <Typography variant="body2" color="text.secondary">
                Usa «Agregar enlace y agendar» en la tarjeta del examen, más abajo.
              </Typography>
            )}
          </Box>
        </Alert>
      ))}
      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  );
}
